import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DialogService } from '@teammood/shared/ui/dialog';
import { from, switchMap } from 'rxjs';
import { Tip } from '@teammood/timeline';
import { TipDialogComponent, TipDialogData } from './tip-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class TipService {

  constructor(
    private httpClient: HttpClient,
    private dialogService: DialogService
  ) { }

  showTips(tip: Tip) {
    return this.httpClient.put(`/timeline/showTips/${tip.id}`, {}).pipe(
        switchMap(() => {
          return from(this.dialogService.open<TipDialogComponent, TipDialogData, any>(TipDialogComponent, {
            minWidth: '380px',
            maxWidth: '960px',
            width: '80%',
            data: { tip }
          }));
        })
    )
  }

  dismissTips(tip: Tip) {
    return this.dismissTipsById(tip.id);
  }

  dismissTipsById(tipsId: String) {
    return this.httpClient.put(`/api/timeline/${tipsId}/dismiss/tips`, {});
  }

  restoreTips(tipsId: String) {
    return this.httpClient.put(`/api/timeline/${tipsId}/restore/tips`, {});
  }
}